import React from "react";
import './index.css'

const ButtonPost = ({Icon, title, link})=>{
    return( 
    <div className="button-post-container">
        <a className="button-post-link-section" target="_blank" href={link}>
            {Icon}
            <p style={{color:'grey'}}>{title}</p>
        </a>            
        </div>)
}

export default ButtonPost